module.exports = __webpack_public_path__ + "static/media/receipt-received.7441779e.svg";